/** Get the billing plan and all its rates for a tenant. */
export const tenantBillingPlanGetSpec = {
    uri: '/t/[tenant]/billing/plan',
    method: 'GET',
};
